import { useAlarmFilters } from '../../hooks/useAlarmFilters';
import { Toggle } from '../Toggle';
import { AlarmMachineFilter } from './AlarmMachineFilter';
import { AlarmSignalFilter } from './AlarmSignalFilter';
import {
  MobileFilterDisplayName,
  MobileFilterSelect,
} from './MobileFilterComponents';

/**
 * Mobile filters for alarms page.
 * Reads/writes filter state directly from URL query params - no props needed.
 */
export function MobileAlarmsFilters() {
  const {
    filters,
    setName,
    setMachines,
    setSignals,
    showAllUsers,
    setShowAllUsers,
  } = useAlarmFilters();

  return (
    <>
      <div className='flex items-center justify-between'>
        <label className='size-p2 text-secondary font-medium'>
          Only show my Pulse alerts
        </label>
        <Toggle
          checked={!showAllUsers}
          onCheckedChange={(checked) => setShowAllUsers(!checked)}
          aria-label='Only show my Pulse alerts'
        />
      </div>

      <MobileFilterDisplayName
        value={filters.name || ''}
        onChange={setName}
        label='Pulse alert name'
      />

      <MobileFilterSelect label='Machine'>
        <AlarmMachineFilter
          selectedValues={filters.machines}
          onChange={setMachines}
          variant='mobile'
        />
      </MobileFilterSelect>

      <MobileFilterSelect label='Signal'>
        <AlarmSignalFilter
          selectedValues={filters.signals}
          onChange={setSignals}
          variant='mobile'
        />
      </MobileFilterSelect>
    </>
  );
}
